<div class="layout-footer">
  <img src="assets/layout/images/co_footer.png" alt="Logo" height="20" class="mr-2" />
  by
  <span class="font-medium ml-2">Ministerio de cultura - 2024</span>
</div>